export const WALLET_CREATE = {
  ON_CREATE_WALLET: 'WALLET_CREATE_ON_CREATE_WALLET',
  ON_WALLET_CREATED: 'WALLET_CREATE_ON_WALLET_CREATED',
  ON_PASSWORD_CHANGE: 'WALLET_CREATE_ON_PASSWORD_CHANGE',
  ON_REPEAT_PASSWORD_CHANGE: 'WALLET_CREATE_ON_REPEAT_PASSWORD_CHANGE',
  ON_RESET_STATE: 'WALLET_CREATE_ON_RESET_STATE'
}

export const WALLET_RESTORE = {
  ON_PASSWORD_CHANGE: 'WALLET_RESTORE_ON_PASSWORD_CHANGE',
  ON_REPEAT_PASSWORD_CHANGE: 'WALLET_RESTORE_ON_REPEAT_PASSWORD_CHANGE',
  ON_MNEMONIC_CHANGE: 'WALLET_RESTORE_ON_MNEMONIC_CHANGE',
  ON_RESTORE_WALLET: 'WALLET_RESTORE_ON_RESTORE_WALLET',
  ON_WALLET_RESTORED: 'WALLET_RESTORE_ON_WALLET_RESTORED',
  ON_RESET_STATE: 'WALLET_RESTORE_ON_RESET_STATE'
}

export const WALLET_BACKUP = {
  ON_COPY_TO_CLIPBOARD: 'WALLET_BACKUP_ON_COPY_TO_CLIPBOARD',
  ON_RESET_STATE: 'WALLET_BACKUP_ON_RESET_STATE'
}

export const WALLET_RECEIVE = {
  ON_COPY_TO_CLIPBOARD: 'WALLET_RECEIVE_ON_COPY_TO_CLIPBOARD',
  ON_RESET_STATE: 'WALLET_RECEIVE_ON_RESET_STATE'
}

export const WALLET_STORAGE = {
  ON_CHECK_STORAGE: 'WALLET_STORAGE_ON_CHECK_STORAGE',
  ON_WALLET_FOUND: 'WALLET_STORAGE_ON_WALLET_FOUND',
  ON_WALLET_NOT_FOUND: 'WALLET_STORAGE_ON_WALLET_NOT_FOUND'
}

export const MENU_ACTIONS = {
  ON_MENU_MOUSE_ENTER: 'MENU_ACTIONS_ON_MENU_MOUSE_ENTER',
  ON_MENU_MOUSE_LEAVE: 'MENU_ACTIONS_ON_MENU_MOUSE_LEAVE',
  ON_MENU_CLICK: 'MENU_ACTIONS_ON_MENU_CLICK',
  ON_CLOSE_MENU: 'MENU_ACTIONS_ON_CLOSE_MENU'
}

export const WALLET_UNLOCK = {
  ON_PASSWORD_CHANGE: 'WALLET_UNLOCK_ON_PASSWORD_CHANGE',
  ON_UNLOCK_WALLET: 'WALLET_UNLOCK_ON_UNLOCK_WALLET',
  ON_WALLET_UNLOCKED: 'WALLET_UNLOCK_ON_WALLET_UNLOCKED',
  ON_WALLET_UNLOCK_ERROR: 'WALLET_UNLOCK_ON_WALLET_UNLOCK_ERROR',
  ON_RESET_STATE: 'WALLET_UNLOCK_ON_RESET_STATE',
  ON_LOCK_WALLET: 'WALLET_UNLOCK_ON_LOCK_WALLET',
}

export const PRIVATE_KEY = {
  ON_COPY_TO_CLIPBOARD: 'PRIVATE_KEY_ON_COPY_TO_CLIPBOARD',
  ON_RESET_STATE: 'PRIVATE_KEY_ON_RESET_STATE'
}

export const PASSWORD_CHANGE = {
  ON_PASSWORD_CHANGE_ACTION: 'PASSWORD_CHANGE_ON_PASSWORD_CHANGE_ACTION',
  ON_PASSWORD_CHANGED_ACTION: 'PASSWORD_CHANGE_ON_PASSWORD_CHANGED_ACTION',
  ON_PASSWORD_CHANGE: 'PASSWORD_CHANGE_ON_PASSWORD_CHANGE',
  ON_REPEAT_PASSWORD_CHANGE: 'PASSWORD_CHANGE_ON_REPEAT_PASSWORD_CHANGE',
  ON_PASSWORD_CHANGE_ERROR: 'PASSWORD_CHANGE_ON_PASSWORD_CHANGE_ERROR',
  ON_RESET_STATE: 'PASSWORD_CHANGE_ON_RESET_STATE'
}

export const TC_ACTIONS = {
  ON_ACCEPT_TC: 'TC_ACTIONS_ON_ACCEPT_TC',
  ON_TC_ACCEPTED: 'TC_ACTIONS_ON_TC_ACCEPTED',
  ON_GET_POLICY_FROM_STORAGE: 'TC_ACTIONS_ON_GET_POLICY_FROM_STORAGE'
}

export const BRANDING_ACTIONS = {
  ON_STORE_BRAND_SYMBOL: 'BRANDING_ACTIONS_ON_STORE_BRAND_SYMBOL',
  ON_FINISH_LOADING: 'BRANDING_ACTIONS_ON_FINISH_LOADING',
  ON_GET_BRAND_DATA: 'BRANDING_ACTIONS_ON_GET_BRAND_DATA',
  ON_BRAND_DATA_RECEIVED: 'BRANDING_ACTIONS_ON_BRAND_DATA_RECEIVED',
  ON_BRAND_DATA_NO_DATA: 'BRANDING_ACTIONS_ON_BRAND_DATA_NO_DATA'
}


// WEBPACK FOOTER //
// ./src/constants/actions.js